/*============================================================================
  #popup new window on same page
==============================================================================*/
// Get the modal
var modal = document.getElementById('myModal-1');

// Get the button that opens the modal
var btn = document.getElementById("myBtn-1");

// Get the <span> element that closes the modal

var span = document.getElementById("close-1");
//var span = document.getElementsByClassName("close")[0];
// When the user clicks the button, open the modal 
if(btn != null) {
  btn.onclick = function() {
  //assign ccs as block
    modal.style.display = "block";
}
}


// When the user clicks on <span> (x), close the modal
if(span != null){
span.onclick = function() {
    modal.style.display = "none";
}
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    }
      if (event.target == modal2) {
        modal2.style.display = "none";
    }
  if (event.target == modal3) {
        modal3.style.display = "none";
    }
  if (event.target == modal4) {
        modal4.style.display = "none";
    }
  if (event.target == modal5) {
        modal5.style.display = "none";
    }
  if (event.target == modal6) {
        modal6.style.display = "none";
    }
  if (event.target == modal7) {
        modal7.style.display = "none";
    }
  if (event.target == modal8) {
        modal8.style.display = "none";
    }
  if (event.target == modal9) {
        modal9.style.display = "none";
    }
  if (event.target == modal10) {
        modal10.style.display = "none";
    }
  if (event.target == modal11) {
        modal11.style.display = "none";
    }
  if (event.target == modal12) {
        modal12.style.display = "none";
    }
  if (event.target == modal13) {
        modal13.style.display = "none";
    }
}
//---------------popup page2----------------

var modal2 = document.getElementById('myModal-2');
var btn2 = document.getElementById("myBtn-2");
var span2 = document.getElementById("close-2");

if(btn2 != null){
btn2.onclick = function() {
    modal2.style.display = "block";
}
}
if(span2 != null){
span2.onclick = function() {
  modal2.style.display = "none";
}
}
//---------------popup page3----------------

var modal3 = document.getElementById('myModal-3');
var btn3 = document.getElementById("myBtn-3");
var span3 = document.getElementById("close-3");
if(btn3 != null){
btn3.onclick = function() {
    modal3.style.display = "block";
}
}
if(span3 != null){
span3.onclick = function() {
  modal3.style.display = "none";
}
}
//---------------popup page4----------------

var modal4 = document.getElementById('myModal-4');
var btn4 = document.getElementById("myBtn-4");
var span4 = document.getElementById("close-4");

if(btn4 != null){
btn4.onclick = function() {
    modal4.style.display = "block";
}
}

if(span4 != null){
span4.onclick = function() {
  modal4.style.display = "none";
}
}
//---------------popup page5----------------

var modal5 = document.getElementById('myModal-5');
var btn5 = document.getElementById("myBtn-5");
var span5 = document.getElementById("close-5");

btn5.onclick = function() {
    modal5.style.display = "block";
}
span5.onclick = function() {
  modal5.style.display = "none";
}

//---------------popup page6----------------

var modal6 = document.getElementById('myModal-6');
var btn6 = document.getElementById("myBtn-6");
var span6 = document.getElementById("close-6");
btn6.onclick = function() {
    modal6.style.display = "block";
}
span6.onclick = function() {
  modal6.style.display = "none";
}

//---------------popup page7----------------

var modal7 = document.getElementById('myModal-7');
var btn7 = document.getElementById("myBtn-7");
var span7 = document.getElementById("close-7");
btn7.onclick = function() {
    modal7.style.display = "block";
}
span7.onclick = function() {
  modal7.style.display = "none";
}

//---------------popup page8----------------

var modal8 = document.getElementById('myModal-8');
var btn8 = document.getElementById("myBtn-8");
var span8 = document.getElementById("close-8");
btn8.onclick = function() {
    modal8.style.display = "block";
}
span8.onclick = function() {
  modal8.style.display = "none";
}

//---------------popup page9----------------

var modal9 = document.getElementById('myModal-9');
var btn9 = document.getElementById("myBtn-9");
var span9 = document.getElementById("close-9");
btn9.onclick = function() {
    modal9.style.display = "block";
}
span9.onclick = function() {
  modal9.style.display = "none";
}

//---------------popup page10----------------

var modal10 = document.getElementById('myModal-10');
var btn10 = document.getElementById("myBtn-10");
var span10 = document.getElementById("close-10");
btn10.onclick = function() {
    modal10.style.display = "block";
}
span10.onclick = function() {
  modal10.style.display = "none";
}

//---------------popup page11----------------

var modal11 = document.getElementById('myModal-11');
var btn11 = document.getElementById("myBtn-11");
var span11 = document.getElementById("close-11");
btn11.onclick = function() {
    modal11.style.display = "block";
}
span11.onclick = function() {
  modal11.style.display = "none";
}

//---------------popup page12----------------

var modal12 = document.getElementById('myModal-12');
var btn12 = document.getElementById("myBtn-12");
var span12 = document.getElementById("close-12");
btn12.onclick = function() {
    modal12.style.display = "block";
}
span12.onclick = function() {
  modal12.style.display = "none";
}

//---------------popup page13----------------

var modal13 = document.getElementById('myModal-13');
var btn13 = document.getElementById("myBtn-13");
var span13 = document.getElementById("close-13");
btn13.onclick = function() {
    modal13.style.display = "block";
}
span13.onclick = function() {
  modal13.style.display = "none";
}


// -------- video

// ------ document.getElementsByClassName("embed-container")[0].style.display = "none"; ----